import { ReactNode, MouseEvent } from 'react';
import Table from '../../../component/table/Table.component';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { Title } from '../../../component/title/Title';
import Modal from '../../../component/modal/Modal.component';
import { HistoricInterface } from './interface/Historic';

interface Historic {
    historic: HistoricInterface[];
    open: boolean;
    handleClick(event: MouseEvent<HTMLElement>): void;
    children: ReactNode;
}

export default function HistoricComponent({ historic, open, handleClick, children }: Historic) {

    return (
        <Modal
            size='md'
            open={open}
            handleClick={handleClick}  >

            <Title fontSize={22}>HISTORICO</Title>
            <br />
            <Table
                data={historic}
                size={historic.length}
                headCells={HEAD_CELL}
            />
            {children}
        </Modal>
    );
}
